import React, {memo, useEffect, useState} from "react";
import { Head, ModelUploader} from "../../components";
import Container from "@mui/material/Container";
import {Box, Paper} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {connect} from "react-redux";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {useParams} from "react-router-dom";


const actions = [
    { name: 'اطلاعات اولیه', 'step' : 0 },
    { name: 'گالری تصاویر', 'step' : 1 },
];

const GalleryCreate = memo((props) => {


    const { entities } = props;
    const { id } = useParams();


    const initStat = {
        title: '',
        is_slider: -1,
        status: -1,
        show_in: ''
    }

    const [step, setStep] = useState(0);
    const [form, setForm] = useState(initStat);
    const [loading, setLoading] = useState(false);


    useEffect(() => {

        new Api().get('/galleries/' + id).then((response) => {
            if (typeof response !== "undefined") {
                setForm(response);
            }
        })

    }, []);


    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().put('/galleries/' + id, form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg)
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }

    const handleChangeTab = (event, newValue) => {
        setStep(newValue);
    };

    const switchStep = () => {
        switch (step) {
            case 0:
                return (
                    <Box mt={5}>
                        <Paper style={{ padding: 25 }}>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} >
                                        <TextField
                                            label="عنوان"
                                            variant="outlined"
                                            margin='dense'
                                            fullWidth
                                            name='title'
                                            value={form.title}
                                            onChange={handleChangeElement}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            select
                                            label="وضعیت"
                                            variant="outlined"
                                            margin='dense'
                                            fullWidth
                                            name='status'
                                            value={form.status}
                                            onChange={handleChangeElement}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >
                                            <MenuItem value={1}>فعال</MenuItem>
                                            <MenuItem value={0}>غیرفعال</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            select
                                            label="اسلایدر"
                                            variant="outlined"
                                            margin='dense'
                                            fullWidth
                                            value={form.is_slider}
                                            name='is_slider'
                                            onChange={handleChangeElement}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >
                                            <MenuItem value={1}>هست</MenuItem>
                                            <MenuItem value={0}>نیست</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            select
                                            label="نمایش"
                                            variant="outlined"
                                            margin='dense'
                                            fullWidth
                                            name='show_in'
                                            value={form.show_in}
                                            onChange={handleChangeElement}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >
                                            {Object.keys(entities.show_in).map((item, index) => {
                                                return(
                                                    <MenuItem value={item}>{entities.show_in[item]}</MenuItem>
                                                );
                                            })}

                                        </TextField>
                                    </Grid>
                                </Grid>
                                <Box mt={5}>
                                    <Button disabled={loading} variant='contained' color='primary' type="submit">ویرایش</Button>
                                </Box>
                            </form>
                        </Paper>
                    </Box>
                );
                break;
            case 1:
                return (<ModelUploader model={'gallery'} entityID={id}/>);
                break;

        }
    };

    return(
        <Container>
            <Head data={{ 'link': '/gallery', 'title': 'ویرایش اسلایدر و گالری تصاویر'}} />
            <Box mt={5}>
                <Paper>
                    <Tabs
                        value={step}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        {actions.map((item) => {
                            return(
                                <Tab label={item.name} />
                            );
                        })}

                    </Tabs>
                </Paper>
                {switchStep()}
            </Box>
        </Container>
    );
})

const mapStateToProps = state => ({
    entities: state.galleryReducer
})

export default connect(mapStateToProps)(GalleryCreate);